import React, { Suspense } from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { ManagedPopup } from 'js/components/common/Popup';
import { TermsConditions } from 'js/components/main/TermsConditions';
import { getOkButton } from 'js/components/common/popups/CommonPopup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { useUserSelector, useTermsConditionsSelector } from 'js/store/hooks';
import { getAcceptDeclineButtons } from 'js/components/common/popups/ConfirmationPopup';

import * as Types from './types';

import style from './TermsConditionsConfirmationPopup.scss';

export const TermsConditionsConfirmationPopup: React.FC<Types.ITermsConditionsConfirmationPopupProps> = ({
    id,
    onAccept,
    onDecline,
    tcVersion
}) => {
    const onAcceptClick = useCombinedOnClose(onAccept, id);
    const onDeclineClick = useCombinedOnClose(onDecline, id);
    const translate = useTranslations('playtech.mobile.system.popup.TC.');
    const lang = useUserSelector(prop('lang')) || '';
    const termsConditions = useTermsConditionsSelector(prop('termsConditions'));
    const termsConditionsPerLang = termsConditions[lang];

    const buttons = termsConditionsPerLang?.error
        ? getOkButton(onDeclineClick)
        : getAcceptDeclineButtons({
            onAcceptClick,
            onDeclineClick
        });

    return (
        <ManagedPopup
            id={id}
            isModal
            buttons={buttons}
            title={translate('title')}
            classNames={{ inner: style.innerContent }}
            layerClassNames={{ layout: style.layout }}
        >
            <Suspense fallback="">
                <TermsConditions tcVersion={tcVersion} />
            </Suspense>
        </ManagedPopup>
    );
};
